import React from "react";
import { Switch, Redirect } from "react-router-dom";
import AppRoute from "./AppRoute";

// Pages
import LoginPage from "pages/Login/LoginPage";
import AboutPage from "pages/About/AboutPage";
import ViewportPage from "pages/Viewport/ViewportPage";
import LaunchpadPage from "pages/Launchpad/LaunchpadPage";
import SettingsPage from "pages/Settings/SettingsPage";
import UserAccountPage from "pages/UserAccount/UserAccountPage";
import NotFoundPage from "pages/NotFound/NotFoundPage";
import LoggedOutPage from "pages/LoggedOut/LoggedOutPage";

function Routes(props) {
  return (
    <Switch>
      <Redirect exact from="/" to="/launchpad" />

      <AppRoute exact path="/launchpad" component={LaunchpadPage} checkBosUserAuth={true} showAppTitle={true} {...props} />
      <AppRoute exact path="/settings" component={SettingsPage} checkBosUserAuth={true} showAppTitle={true} {...props} />
      <AppRoute exact path="/about" component={AboutPage} showAppTitle={true} {...props} />

      <AppRoute exact path="/account" component={UserAccountPage} checkBosUserAuth={true} showAppTitle={true} {...props} />

      <Redirect from="/logout/:logoutreason" to="/logout?logoutreason=:logoutreason" />
      <AppRoute exact path="/logout" component={LoggedOutPage} clearCurrentDataSegment={true} showAppTitle={false} {...props} />

      <Redirect from="/tokenlogin/:logintoken" to="/login?logintoken=:logintoken" />
      <Redirect from="/emailverification/:verifytoken" to="/login?verifytoken=:verifytoken" />
      <AppRoute exact path="/login" component={LoginPage} clearCurrentDataSegment={true} showAppTitle={false} {...props} />

      <AppRoute path="/:uri+" component={ViewportPage} checkBosUserAuth={true} {...props} />

      <AppRoute component={NotFoundPage} />
    </Switch>
  );
}

export default Routes;
